import { render } from "./IntentionListModal.vue?vue&type=template&id=4c76a780"
import script from "./IntentionListModal.vue?vue&type=script&lang=js"
export * from "./IntentionListModal.vue?vue&type=script&lang=js"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__